import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import {
  DEFAULT_LANGUAGE,
  LANGUAGE_STORAGE_KEY,
  normalizeDetectedLanguage,
} from './constants';
// Register framework-agnostic side effects (moment locale sync) before init so
// the listener catches the initial `languageChanged` event.
import './sideEffects';
import ptBR from './locales/pt-BR';
import enUS from './locales/en-US';
import es419 from './locales/es-419';

export const resources = {
  'pt-BR': { translation: ptBR },
  'en-US': { translation: enUS },
  'es-419': { translation: es419 },
} as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    // Safety net for a language set programmatically rather than detected
    // (`convertDetectedLanguage` already narrows anything coming from the
    // detector to a supported regional variant).
    fallbackLng: {
      pt: ['pt-BR'],
      en: ['en-US'],
      es: ['es-419'],
      default: [DEFAULT_LANGUAGE],
    },
    supportedLngs: ['pt-BR', 'en-US', 'es-419'],
    load: 'currentOnly',
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
      caches: ['localStorage'],
      convertDetectedLanguage: normalizeDetectedLanguage,
    },
    interpolation: { escapeValue: false },
    returnNull: false,
    // Resources are bundled inline, so initialize synchronously and skip
    // Suspense (there is no Suspense boundary around the app).
    initImmediate: false,
    react: { useSuspense: false },
  });

export default i18n;
